var _defs, _polyline, _polyline2, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelationsSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #009ad9;\n      }\n\n      .st1 {\n        fill: #363545;\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "24.7 19.3 24.7 7.1 14.9 7.1 14.9 5.1 26.7 5.1 26.7 21.3"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "9.1 26.3 9.1 7.1 6.3 7.1 6.3 5.1 11.1 5.1 11.1 28.3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 5.7,
    y: 2.2,
    width: 16,
    height: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 6,
    y: 22.5,
    width: 8.5,
    height: 8.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 21.4,
    y: 14.7,
    width: 8.5,
    height: 8.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationsSvg);
export default __webpack_public_path__ + "static/media/Relations_svg.726ca9ebfe6ce7e267c7c28d205958bb.svg";
export { ForwardRef as ReactComponent };